
import Layout from '../../components/feature/Layout';
import ContactHero from './components/ContactHero';
import ContactInfo from './components/ContactInfo';
import ContactMapForm from './components/ContactMapForm';
import ContactCTA from './components/ContactCTA';

export default function ContactPage() {
  return (
    <Layout>
      <div className="min-h-screen bg-white">
        <ContactHero />
        <ContactInfo />
        <ContactMapForm />
        <ContactCTA />
      </div>
    </Layout>
  );
}
